import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme, Typography } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { FormGroup } from '../../components/FormGroup';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';
import { api } from '../../api';
import { useLoading } from '../../units/loading';
import { useAlert } from '../../units/alert';
import { StatusFalseError } from '../../api/error/StatusFalseError';
import { usePartner } from '../../hooks/usePartner';
import { FrontNewsMoreRequestData } from '../../api/frontNewsMore';
import { useLiff } from '../../units/liff';
import { useQuery } from '../../units/useQuery';

type MoreNewsPageProps = {};

MoreNewsPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function useFormData() {
    const [formData, setFormData] = useState<FrontNewsMoreRequestData>({
        line_uid: '',
        login: '',
        id: '',
        connect_name: '',
        connect_mail: '',
        connect_phone: '',
    });

    return {
        formData,
        setFormData,
    };
}

function MoreNewsPage(props: MoreNewsPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const query = useQuery();
    const { setIsLoading } = useLoading();
    const alert = useAlert();
    const { formData, setFormData } = useFormData();
    const { liff, isLoadLiff, isInClient, isReady } = useLiff();
    const { partner, isLoading: isPartnerLoading, partnerLineUid } = usePartner();
    const [isSubmitted, setSubmitted] = useState(false);

    useEffect(() => {
        setIsLoading(isPartnerLoading);
        if (partner) {
            setFormData({
                ...formData,
                connect_name: partner.name,
                connect_mail: partner.email,
                connect_phone: partner.phone,
            });
        }
    }, [isPartnerLoading]);

    function handleSubmitClick() {
        setIsLoading(true);
        api.frontNewsMore({
            ...formData,
            id: query.get('newsId') || '',
            login: partner?.email || '',
            line_uid: partnerLineUid || '',
        })
            .then(() => {
                setSubmitted(true);
                setIsLoading(false);
                alert.show({
                    type: 'success',
                    title: '操作成功',
                    message: '客服專員將會盡快與您聯繫',
                    onConfirm: () => {
                        if (isLoadLiff() && isReady && isInClient) {
                            liff.closeWindow();
                        }
                    },
                });
            })
            .catch(async (e) => {
                setIsLoading(false);
                if (e instanceof StatusFalseError) {
                    const errorData = await e.response.json();
                    alert.show({
                        type: 'error',
                        title: '錯誤',
                        message: errorData.msg,
                    });
                }
            });
    }

    function canSubmit() {
        return formData.connect_name
            && (formData.connect_mail || formData.connect_phone);
    }

    return (
        <Page>
            <BackAppBar title="了解更多" />
            <PageBody>
                <FormGroup title="聯絡資訊">
                    <TextField
                        label="聯絡人姓名"
                        value={formData.connect_name}
                        onChange={(e) => setFormData({
                            ...formData,
                            connect_name: e.target.value,
                        })}
                        required
                        disabled={isSubmitted}
                    />
                    <TextField
                        label="聯絡人mail"
                        value={formData.connect_mail}
                        onChange={(e) => setFormData({
                            ...formData,
                            connect_mail: e.target.value,
                        })}
                        disabled={isSubmitted}
                    />
                    <Typography variant="caption" style={{ marginLeft: 8, whiteSpace: 'nowrap' }}>
                        /
                        <span style={{ marginLeft: 8, color: '#cf8755' }}>*mail與電話擇一輸入即可</span>
                    </Typography>
                    <TextField
                        label="聯絡人電話"
                        value={formData.connect_phone}
                        onChange={(e) => setFormData({
                            ...formData,
                            connect_phone: e.target.value,
                        })}
                        disabled={isSubmitted}
                    />
                </FormGroup>
                <FormGroup>
                    <Button onClick={handleSubmitClick} disabled={!canSubmit()}>送出</Button>
                </FormGroup>
            </PageBody>
        </Page>
    );
}

export { MoreNewsPage };
